var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCause5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.6 206.5",
    style: {
      enableBackground: "new 0 0 108.6 206.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6E6E6;stroke:#6F77B9;stroke-miterlimit:10;}\n\t.st1{fill:#0A236B;}\n\t.st2{fill:#384F9B;}\n\t.st3{fill:none;stroke:#000000;stroke-width:0.4;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000180337327237583407810000000516118691533829297_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "24.6,97.7 36.9,99.3 44.9,100.9 50.7,103.1 62.3,103.1 78.4,99 88.3,99 98.7,100.4 102,105.1  106.6,121 104.9,132.6 104.8,145.1 102,155.2 100.4,164.7 99.7,175.8 99.3,186 96.2,192.5 93.5,200.6 88.3,203.6 83.6,203.6  79.2,201.6 72.3,193.8 68.8,186.4 67.5,179.9 67,174.2 60.5,166.7 55.4,166.7 50.2,170.7 45.3,186 41.5,197.4 35.4,203.6  29.8,206.5 24.2,199.9 15.9,190 15.4,173.5 12.5,159.3 11.4,143.5 2.6,125.4 6.9,103.1 9.5,101.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3,47.8C6.5,52,9.7,51,9.3,52.4s0,5.7,2.5,7.8s8.8,2.9,12.3,3.2s14.1-4.6,14.1-4.6s2.5,6,8.5,6.4 s21.5-1.4,23.2-3.5s2.8-3.2,3.9-3.2s9.2,3.2,13.4,2.8s9.9-1.8,11-4.2s2.5-6.3,2.5-6.3s1.4,1.4,3.5-0.7s6-1.4,3.5-8.1 s-8.1-14.2-11.3-16.6s-13.1-6.4-18-7.4S61.6,16,58,15.3s-17.7,0.4-20.5,1.1c-2.8,0.7-14.4,4.2-15.5,4.9S6.2,29.8,4.8,31.5 c-1.4,1.8-5.7,4.6-4.6,8.8C0.8,42.9,1.8,45.4,3,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3,47.8c-0.3-3.5-0.3-9.5,3.2-10.9s10.9,3.9,10.9,3.9s1-3.9,6.4-4.6s14.1,3.9,14.4,5.3s0.7-3.9,6-6 s18-5.6,21.9-1.8S70,44.2,70,44.2s7-10.6,12.7-9.9s9.2,3.2,8.5,6s1.4-1.8,5.3-2.1s6,3.9,8.5,4.2s3.9,5.7,1.8-7.4 s-16.6-24-21.9-28.2S71.1,3.3,69.7,3s-3.9-2.5-6-2.9s-6.3,0-7.4,0.7C55,1.7,53.5,2.3,52,2.6c-1.7,0.4-4.5-1.8-6-2.1 c-1.5-0.5-3.1-0.5-4.6,0c-1.8,0.7-6,2.8-6,2.8l-5.2,3.5c0,0-4.2-1.4-7.4-0.3S10.1,16.7,6.5,23.4s-6.3,12-6.3,16.9 C0.1,43.1,1.1,45.8,3,47.8z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "3,47.8 54,103.8 17.1,40.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "70,44.2 55.6,106 37.9,41.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "107.8,41.8 55.6,106 91.2,40.4  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause5);
export default __webpack_public_path__ + "static/media/cause_5.8bc108a7f06c11ded98982457e1e7033.svg";
export { ForwardRef as ReactComponent };